export default __webpack_public_path__ + "static/media/i063vk.66c27082.webp";